@if (isAuthenticated) {
  <app-version-nav></app-version-nav>
} @else {
  <app-header></app-header>
}
<div class="about-container">
  <div class="about-content">
    <h1>About AIOptima</h1>
    
    <section class="about-section">
      <h2>Our Mission</h2>
      <p>
        AIOptima is dedicated to empowering businesses with comprehensive AI-powered brand analytics 
        and insights. We help organizations understand their brand presence, consumer perceptions, 
        and competitive positioning through advanced artificial intelligence and data analytics.
      </p>
    </section>

    <section class="about-section">
      <h2>What We Do</h2>
      <p>
        Our platform provides real-time brand analysis across multiple industries and categories, 
        offering deep insights into:
      </p>
      <ul>
        <li>Brand visibility and AI search presence</li>
        <li>Consumer insights and demographic analysis</li>
        <li>Content performance and optimization recommendations</li>
        <li>Competitive positioning and market trends</li>
        <li>Prompt creation and tracking capabilities</li>
      </ul>
    </section>

    <section class="about-section">
      <h2>Our Technology</h2>
      <p>
        AIOptima leverages cutting-edge AI models and web scraping technologies to gather and analyze 
        brand data from multiple sources. Our platform uses advanced natural language processing and 
        machine learning algorithms to provide actionable insights that help businesses make 
        data-driven decisions.
      </p>
    </section>

    <section class="about-section">
      <h2>Contact Us</h2>
      <p>
        For inquiries, support, or partnership opportunities, please reach out to us through our 
        platform or contact our team directly.
      </p>
    </section>
  </div>
</div>
